import { component } from "picoapp";

export const stayAILogin = component((node) => {
  const appName = "retextion";
  const customerId = node?.dataset?.customerId || window.__st.cid;
  const loginRetextionCustomerPortal = (e: MouseEvent) => {
    e.preventDefault();
    if (customerId) {
      // Construct an HTTP request
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/apps/" + appName + "/login", true);
      xhr.setRequestHeader("Accept", "application/json; charset=utf-8");
      xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
      // Send the collected data as JSON
      const data = {
        customerId,
      };
      xhr.send(JSON.stringify(data));
      xhr.addEventListener("loadend", () => {
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText);
          if (data.token) {
            const oneHour = 60 * 60 * 1000;
            localStorage.setItem("customer-portal-token", data.token);
            localStorage.setItem(
              "customer-portal-token-expiration",
              `${new Date().getTime() + oneHour}`
            );
            window.location.replace(
              "/apps/" + appName + "/#/shop/subscriptions"
            );
          }
        }
      });
    } else {
      window.location.replace("/apps/" + appName + "/#/login");
    }
  };

  const triggerElement = node.querySelector<HTMLAnchorElement>(
    "a[href='/apps/retextion/login']"
  );
  if (triggerElement) {
    triggerElement.addEventListener("click", loginRetextionCustomerPortal);
  }

  return () => {
    if (triggerElement) {
      triggerElement.removeEventListener("click", loginRetextionCustomerPortal);
    }
  };
});
